var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepoCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.48627,
    r: 7.5,
    fill: "#B7E8C5",
    fillOpacity: 0.31
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.50003,
    cy: 8.48627,
    r: 4.64286,
    fill: "#B7E8C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71436 8.36724L6.98987 9.55771L9.28578 7.41486",
    stroke: "white",
    strokeWidth: 0.714286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepoCompleted);
export default __webpack_public_path__ + "static/media/RepoCompleted.57b1d3f8252fc1d9d16052c8e35e2203.svg";
export { ForwardRef as ReactComponent };